import { render, staticRenderFns } from "./studentConfirmedPaper.vue?vue&type=template&id=34cf83af&"
import script from "./studentConfirmedPaper.vue?vue&type=script&lang=js&"
export * from "./studentConfirmedPaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports